module.exports = __webpack_public_path__ + "img/4_4.10550abe.png";